module.exports = __webpack_public_path__ + "static/media/6.21.0b41af2b.png";